import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { CompanyDetailsComponent } from '../company-details.component';

@Component({
  selector: 'app-edit-company',
  templateUrl: './edit-company.component.html',
  styleUrls: ['./edit-company.component.scss']
})
export class EditCompanyComponent implements OnInit {

  @ViewChild('closeBtn') closeBtn: ElementRef;
  @Input() companyData: any

  editCompanyForm: FormGroup;
  missingFieldMsg = false;
  errorMsg: boolean;

  constructor(private formBuilder: FormBuilder,
    private authService: AuthenticationService,
    private companyDetails: CompanyDetailsComponent, private appComp: AppComponent ) {
      this.editCompanyForm = this.formBuilder.group({
        name: ["", Validators.required],
        contact: ["", Validators.required],
        address1: ["", Validators.required],
        address2: [""],
        city: ["", Validators.required],
        state: ["", Validators.required],
        zip: ["", Validators.required],
        phone: ["", Validators.required],
        email: ["", Validators.required],
        contactPhone: ["", Validators.required],
        contactEmail: ["", Validators.required],
        isLoan: [Boolean, Validators.required],
        active: [null],
      });
    }

  ngOnInit() {
    
  }

  ngOnChanges() { 
    this.errorMsg = false;  
    if(this.companyData){
      this.editCompanyForm.patchValue({
        name: this.companyData.name,
        contact: this.companyData.contact,
        address1: this.companyData.address1,
        address2: this.companyData.address2,
        city: this.companyData.city,
        state: this.companyData.state,
        zip: this.companyData.zip,
        phone: this.companyData.phone,
        email: this.companyData.email,
        contactPhone: this.companyData.contactPhone,
        contactEmail: this.companyData.contactEmail,
        active: this.companyData.active
      })
    }
    
  }

  editCompany(){
    this.appComp.loading = true;
    this.errorMsg = false;
    this.missingFieldMsg = false;
    if (this.editCompanyForm.invalid) {
      this.missingFieldMsg = true;
      this.appComp.loading = false;
      return;
    }
    let formObj = this.editCompanyForm.getRawValue();
    //console.log(formObj);
    formObj.id = this.companyData.id;
    // console.log(formObj.active);
    if(typeof formObj.active == "string"){
      formObj.active = formObj.active == 'true' ? true : false;
    }
    console.log(formObj.active);
    this.authService.editCompany(formObj).then(res=>{
      // console.log(res);
      this.closeBtn.nativeElement.click();
      this.companyDetails.getCompanyDetails(this.companyData.id);
      this.appComp.loading = false;
    }, err =>{
      this.errorMsg = true;
      // console.log(err);
      this.appComp.loading = false;
    })
  }

}
